import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import ListingDetail from "@/pages/ListingDetail";
import ChiSiamo from "@/pages/ChiSiamo";
import DoveSiamo from "@/pages/DoveSiamo";
import { IVAffitti, IVServizi, IVCall } from "@/pages/Servizi";
import LavoraConNoi from "@/pages/LavoraConNoi";
import Contatti from "@/pages/Contatti";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const PublicLayout = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <>
      <Header />
      <main className="min-h-[50vh]"><Outlet /></main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/immobili" element={<Listings />} />
              <Route path="/immobili/:id" element={<ListingDetail />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/dove-siamo" element={<DoveSiamo />} />
              <Route path="/ivaffitti" element={<IVAffitti />} />
              <Route path="/ivservizi" element={<IVServizi />} />
              <Route path="/ivcall" element={<IVCall />} />
              <Route path="/lavora-con-noi" element={<LavoraConNoi />} />
              <Route path="/contatti" element={<Contatti />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
